export const AmsZipCodeMaxLength = 5;
export const AmsVidMaxLength = 32;
export const AmsSidMinValue = 1;

export interface AmsMappingFormValue {
  id: string | null;
  zipCode: string;
  vid: string;
}

export interface AmsParametersFormValues {
  sid: string;
  mappings: AmsMappingFormValue[];
}
